import { Card } from 'react-bootstrap';

const OrgChartImages = ({ className, src, name, aka, middleInitial, hasSuffix=false, text, year, highestPosition }) => {
  let nameParts = name.split(' ');
  let sliceIndex = hasSuffix ? -2 : -1;

  // 1. Get the base parts
  let firstParts = nameParts.slice(0, sliceIndex).join(' ');
  let lastAndSuffix = nameParts.slice(sliceIndex).map((part, i) => (i === 0 ? part : ` ${part}`));

  // 2. Prepare the optional components
  // We include the leading space inside the spread so it disappears if the item is missing
  let akaComponent = aka ? [' ', <strong className="aka-component" key="aka">"{aka}"</strong>] : [];
  let middleComponent = middleInitial ? [' ', middleInitial, '.'] : [];

  // 3. Build the final array
  // If EITHER aka or middleInitial exists, we build the complex array. 
  // Otherwise, we return the original name.
  let displayName = (aka || middleInitial) ? [firstParts, ...akaComponent, ...middleComponent, ' ', ...lastAndSuffix] : name;

  return (
    <Card className={className}>
      <Card.Img variant="top" src={src} />
      <Card.Body>
        <Card.Title><h4>{displayName}</h4></Card.Title>
        <Card.Text>{year ? year : text}</Card.Text>
        {highestPosition && (
          <Card.Text>
            {highestPosition}
          </Card.Text>
        )}
        {/* <Button variant="primary">Go somewhere</Button> */}
      </Card.Body>
    </Card>
  );
}

export default OrgChartImages;